export const getEffectivePenalty = (transaction) =>
  transaction?.isPenaltyIgnored ? 0 : Number(transaction?.penaltyAmount || 0);
